<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { getdataAmat } from './dataAmat.js';
import config from '../../../../../configHttp';
import { getYear, getFinancialPeriod, getDetailType, reportSubmit, inquiryAliasConfig, getTCodeByNumber, getCurrencyConfigData } from '../../../../api/home.js';
export default {
	name: 'BalanceSheet',
	data() {
		return {
			fxdmData: [],
			baoblx: ['1'],
			//基本信息
			formlistjbxx: this.projectType=='Amat' ? getdataAmat().formlistjbxx : getdata().formlistjbxx, 
			formdatajbxx: this.projectType=='Amat' ? getdataAmat().formdatajbxx : getdata().formdatajbxx,
			rangs: []
		};
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	watch: {
		'formdatajbxx.cains': function(indexVal, oldVal) {
			this.formdatajbxx.qij = '';
			this.GainCwqj(indexVal);
		},
		'formdatajbxx.sfjdsc': function(indexVal, oldVal) {
			if (indexVal == "1"){
				this.formlistjbxx[5].disabled = false;
				this.formdatajbxx.cwjd = "1";
			} else{
				this.formlistjbxx[5].disabled = true;
				this.formdatajbxx.cwjd = "";
			}
		}
	},
	methods: {
		selectTrigger(index) {
			let params = {};
			params.number = this.fxdmData[index].tcode;
			getTCodeByNumber(params).then(res => {
				if (res.data.code == '200') {
					this.rangs[index] = res.data.data.map(v => {
						return {
							label: v.refCode,
							value: v.refCode
						};
					});
					this.$forceUpdate();
				}
			});
		},
		//获取分析代码
		GainFXDM() {
			inquiryAliasConfig().then(res1 => {
				if (res1.data.code == '200') {
					this.fxdm = [];
					for (var i in res1.data.data) {
						if (i.substring(0, 5) == 'tcode' && this.$notemptyandnull(res1.data.data[i]) && i.length < 10) {
							this.fxdm.push({ label: res1.data.data[i], value: i.slice(5) });
						}
					}

					// if (res1.data.data.tcode1 != '' && res1.data.data.tcode1 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode1, value: '1' });
					// }
					// if (res1.data.data.tcode2 != '' && res1.data.data.tcode2 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode2, value: '2' });
					// }
					// if (res1.data.data.tcode3 != '' && res1.data.data.tcode3 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode3, value: '3' });
					// }
					// if (res1.data.data.tcode4 != '' && res1.data.data.tcode4 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode4, value: '4' });
					// }
					// if (res1.data.data.tcode5 != '' && res1.data.data.tcode5 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode5, value: '5' });
					// }
					// if (res1.data.data.tcode6 != '' && res1.data.data.tcode6 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode6, value: '6' });
					// }
					// if (res1.data.data.tcode7 != '' && res1.data.data.tcode7 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode7, value: '7' });
					// }
					// if (res1.data.data.tcode8 != '' && res1.data.data.tcode8 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode8, value: '8' });
					// }
					// if (res1.data.data.tcode9 != '' && res1.data.data.tcode9 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode9, value: '9' });
					// }
					// if (res1.data.data.tcode10 != '' && res1.data.data.tcode10 != null) {
					// 	this.fxdm.push({ label: res1.data.data.tcode10, value: '10' });
					// }
				}
			});
		},
		//通过验证后保存
		getdatajbxx() {
			let params = {};
			params.json = JSON.stringify({ name: '资产负债表后台任务', taskDesc: 'test', subType: '6' });
			let param = {};
			param.cains = [];
			param.cains.push(this.formdatajbxx.cains.toString());
			param.qij = [];
			param.qij.push(this.formdatajbxx.qij.toString());
			param.mingxlx = this.formdatajbxx.mingxlx;
			param.currency = this.formdatajbxx.currency;
			param.sfjdsc = this.formdatajbxx.sfjdsc;
			param.cwjd = this.formdatajbxx.cwjd;
			param.baoblx = this.baoblx;
			param.tCodes = this.fxdmData;
			params.param = JSON.stringify(param);
			reportSubmit(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('生成成功');
					this.$router.push({
						path: '/ReportTask'
					});
					// this.empty();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//生成按钮验证
		generate() {
			this.$refs.taxformjbxx.submitForm();
		},
		//重置
		empty() {
			this.formdatajbxx = this.projectType=='Amat' ? getdataAmat().formdatajbxx : getdata().formdatajbxx;
			this.fxdmData = [];
			this.baoblx = [];
			this.rangs = [];
			this.$nextTick(() => {
				this.$refs['taxformjbxx'].clearValidate();
			});
		},
		//初始化查询
		searrchForData() {
			this.formlistjbxx = this.projectType=='Amat' ? getdataAmat().formlistjbxx : getdata().formlistjbxx;
			this.GainNd();
			this.GainMxlx();
			this.GainFXDM();
			this.GainBz();
		},
		//获取币种 TODO 默认选中本币
		GainBz() {
			let params = {};
			getCurrencyConfigData().then(res => {
				if (res.data.code == '200') {
					res.data.data.map(v => {
						if (v.standardCurrency == '1') {
							this.formdatajbxx.currency = v.currency;
						}
						return {
							label: v.currency,
							value: v.currency
						};
					});
					// this.formlistjbxx[3].selectval = res.data.data.map(v => {
					// 	if (v.standardCurrency == '1') {
					// 		this.formdatajbxx.currency = v.currency;
					// 	}
					// 	return {
					// 		label: v.currency,
					// 		value: v.currency
					// 	};
					// });
				}
			});
		},
		//获取年度
		GainNd() {
			let params = {};
			getYear().then(res => {
				this.formdatajbxx.cains = new Date().getFullYear();
				for (var i = res.data.data.max; i >= res.data.data.min; i--) {
					this.formlistjbxx[0].selectval.push({
						label: i,
						value: i
					});
				}
			});
		},
		//获取明细类型
		GainMxlx() {
			let params = {};
			getDetailType().then(res => {
				if (res.data.code == '200') {
					let mingxlx = this.projectType=='Amat' ? this.formlistjbxx[2] : this.formlistjbxx[3];
					mingxlx.selectval = res.data.data.map(v => {
						return {
							label: v.name,
							value: v.value
						};
					});
				}
			});
		},
		//获取财务期间
		GainCwqj(year) {
			let params = {};
			params.year = year;
			getFinancialPeriod(params).then(res => {
				if (res.data.code == '200') {
					this.formlistjbxx[1].selectval = res.data.data.map(v => {
						return {
							label: v.name,
							value: v.value
						};
					});
				} else {
					this.formdatajbxx.qij = '';
					this.formlistjbxx[1].selectval = [];
				}
				let currencyMonth = new Date().getMonth() + 1;
				this.formdatajbxx.qij = currencyMonth;
			});
		},
		adddm(k) {
			let inte = k + 1;
			this.fxdmData.splice(inte, 0, {});
		},
		deletedm(k) {
			this.rangs.splice(k, 1);
			this.fxdmData.splice(k, 1);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
